import React from 'react';
import '../styles/components/button.css';

const Button = ({
  children = 'Button',
  width,
  height,
  padding,
  backgroundColor,
  color,
  onClick,
  className = '',
  ...props
}) => {
  const customStyle = {
    ...(width && { width }),
    ...(height && { height }),
    ...(padding && { padding }),
    ...(backgroundColor && { backgroundColor }),
    ...(color && { color }),
  };

  return (
    <button
      className={`button ${className}`}
      style={customStyle}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
